import Switch from '@mui/material/Switch';
import styled from 'styled-components';
export const SwitchStyled = styled(Switch).attrs({
    disableRipple: true,
})(({ theme, }) => ({
// Add styles here
}));
//# sourceMappingURL=Switch.styles.js.map